const organizationUnits = [
  "IT Department",
  "Administration",
  "Customer Service",
  "Engineering",
  "Finance",
  "Human Resources",
  "Legal",
  "Marketing",
  "Operations",
  "Product Development",
  "Research and Development",
  "Sales",
  "Security",
  "Support",
  "Technical Support",
  "Web Development",
  "Cloud Services",
  "Data Center",
  "DevOps",
  "E-Commerce",
  "Infrastructure",
  "Network Operations",
  "Quality Assurance",
  "Server Administration",
  "Software Development",
  "System Administration",
];

export default organizationUnits;
